import { render, staticRenderFns } from "./alarmHERCULES.vue?vue&type=template&id=36ca5353&scoped=true"
import script from "./alarmHERCULES.vue?vue&type=script&lang=js"
export * from "./alarmHERCULES.vue?vue&type=script&lang=js"
import style0 from "./alarmHERCULES.vue?vue&type=style&index=0&id=36ca5353&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ca5353",
  null
  
)

export default component.exports